var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarrito(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_170182",
    "data-name": "Grupo 170182",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.82,
    height: 39.551,
    viewBox: "0 0 37.82 39.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_150854",
    "data-name": "Rect\\xE1ngulo 150854",
    width: 37.82,
    height: 39.551,
    fill: "#f3f2ee"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_170180",
    "data-name": "Grupo 170180",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86235",
    "data-name": "Trazado 86235",
    d: "M24.793,22.292a4.489,4.489,0,0,1-.139-2.746l.479-5.74c.059-1.366.426-1.539,1.421-1.007.214,1.058-.335,6.341-.507,8.03-.106,1.041.043,1.719-1.255,1.463M19.214,12.8c1-.683,1.363-.062,1.459,1.04.094,1.083.143,2.155.242,3.09.105.988.161,2.2.214,3.145.075,1.324.5,2.42-1.044,2.252-.553-.848-.467-2.935-.607-4.618a26.454,26.454,0,0,1-.264-4.909m12.292-.206c1.533-.117,1.105.9.874,1.921-.375,1.657-1.231,7.6-1.858,7.9-1.964.932-.378-3.872-.259-4.5.091-.481.089-1.013.193-1.5l.586-2.528c.186-.855.035-.673.463-1.287M15.953,19.935c.163.647.693,2.277-.182,2.521-1.044.292-1.049-1.256-1.22-2.051l-1.074-5.289c-.319-1.715-.546-1.709.015-2.559,1.281-.2,1.153.81,1.362,1.8ZM13.88,25.994c.392-.3,7.445-.123,8.471-.123,2.932,0,5.865,0,8.8,0,2.8.006,2.515-.991,3.749-4.972l2.058-6.734c.507-2.1,2.31-5.385-1.539-5.383q-4.4,0-8.8,0c-5.732,0-11.971.235-17.64-.016-.636-1.39-1.015-3.55-1.594-5.035a5.791,5.791,0,0,0-1.9-2.342C4.538.766.753-.8.027.5c-.245.94,1.261,1.538,2.719,2.128,2.023.819,2.717.733,3.358,2.894L9.187,15.8c.545,1.484,1.128,3.463,1.576,5.062.516,1.842,1.373,3.418,1.12,5.51-.723,5.96.841,4.908,8.068,4.908,1.683,0,12.74.162,13.406-.066.8-.273.862-1.609-.466-1.69l-10.008,0H16.219c-.881,0-2.631.316-2.774-.532-.136-.807.018-2.662.435-3",
    transform: "translate(0 0)",
    fill: "#f3f2ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86236",
    "data-name": "Trazado 86236",
    d: "M59.7,163.475c1.661-1.248,3.217,1.3,1.746,2.409a1.488,1.488,0,1,1-1.746-2.409m.071-1.947a3.073,3.073,0,0,0-1.931,1.283,3.308,3.308,0,0,0,3.493,5.072,3.348,3.348,0,0,0,2.393-4,3.253,3.253,0,0,0-3.954-2.352",
    transform: "translate(-45.563 -128.428)",
    fill: "#f3f2ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86237",
    "data-name": "Trazado 86237",
    d: "M134.906,163.475c1.661-1.248,3.217,1.3,1.746,2.409a1.488,1.488,0,1,1-1.746-2.409m.071-1.947a3.073,3.073,0,0,0-1.931,1.283,3.308,3.308,0,0,0,3.493,5.072,3.348,3.348,0,0,0,2.393-4,3.253,3.253,0,0,0-3.954-2.352",
    transform: "translate(-105.415 -128.428)",
    fill: "#f3f2ee",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrito);
export default __webpack_public_path__ + "static/media/Carrito.449582659b585ecd5c6fd5e091870720.svg";
export { ForwardRef as ReactComponent };